import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { FaHeart } from "react-icons/fa"
import { MdPlayArrow, MdPause, MdVolumeOff, MdVolumeUp } from "react-icons/md"
import { HiOutlineShoppingCart } from "react-icons/hi"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"
import { IoStar } from "react-icons/io5"
import { GrSecure } from "react-icons/gr"
import { v4 as uuidv4 } from "uuid"
import pdfDownload from "../images/pdf-download-new.svg"

const CloseTheSale = () => {
  const {
    selectedSign,
    audioEnded,
    mainAudio,
    setCurrentAudioStage,
    setAudioEnded,
    setCurrentStep,
    setFirstName,
    setLastName,
    currentAudioTime,
    currentAudioStage,
    firstName,
    lastName,
    emailAddress,
    buttonClickAudio,
  } = useSiteContext()

  const [disappearing, setDisappearing] = useState(false)
  const [stage, setStage] = useState(1) // Set back to 1
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false)
  const [isBorderAnimating, setIsBorderAnimating] = useState(false)
  const [agreed, setAgreed] = useState(false)
  const [isAgreementError, setIsAgreementError] = useState(false)

  const isBrowser = typeof window !== "undefined"

  async function conversionsAPI(eventID, eventType) {
    const cookies = document.cookie.split(";")
    let fbp = "none"
    let fbc = "none"

    cookies.map(cookie => {
      if (cookie.includes("_fbp=")) {
        fbp = cookie.slice(cookie.indexOf("_fbp=") + 5)
        console.log(fbp)
      }
    })
    cookies.map(cookie => {
      if (cookie.includes("_fbc=")) {
        fbc = cookie.slice(cookie.indexOf("_fbc=") + 5)
        console.log(fbc)
      }
    })

    if (fbc === "none" && window.location.search.includes("fbclid=")) {
      const params = new URL(document.location).searchParams
      fbc = "fb.1." + new Date() + "." + params.get("fbclid")
    }
    try {
      const res = await fetch("/.netlify/functions/conversions-api", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          eventType: eventType,
          fbp,
          fbc,
          sessionID: eventID,
        }),
      })
      const result = await res.json()
      console.log("Return from netlify functions conversionsAPI =", result)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  function encodeString(str) {
    let temp1 = ""
    let temp2 = ""

    temp1 = escape(str)
    for (let i = 0; i < temp1.length; i++) {
      temp2 += temp1.charCodeAt(i) - 23
    }

    return temp2
  }

  async function handleOrder() {
    let url

    // Astrozens
    if (
      window.location.search.includes("test=14") ||
      !window.location.search.includes("hop=astrozens")
    ) {
      url =
        "https://truthstars.pay.clickbank.net/?cbitems=14&cbfid=58060&template=newest1&exitoffer=exit2"
    } else {
      url =
        "https://truthstars.pay.clickbank.net/?cbitems=9&cbfid=58060&template=newest1&exitoffer=exit2"
    }

    // Astroveo
    if (
      window.location.search.includes("affiliate=astroveo") &&
      window.location.search.includes("tid=Facebook")
    ) {
      url =
        "https://truthstars.pay.clickbank.net/?cbitems=9&cbfid=58060&template=newest1&exitoffer=exit2"
    }

    url =
      url +
      "&email=" +
      emailAddress +
      "&sign=" +
      selectedSign +
      "&fname=" +
      encodeString(firstName) +
      "&lname=" +
      encodeString(lastName)

    // Add direct offer tracking parts to URL
    // Create a URL object to parse the original URL
    const urlObj = new URL(document.getElementById("affiliatelink").href)

    // Loop through each query parameter in the original URL
    urlObj.searchParams.forEach((value, key) => {
      // Append the query parameter to finalURL
      url = new URL(url)
      url.searchParams.append(key, value)
    })

    console.log(url.toString())

    if (!agreed) {
      setIsAgreementError(true)

      // Scroll to bottom to see error message
      const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

      if (isFirefox) {
        // Custom smooth scroll for Firefox to bottom
        const smoothScrollToBottom = () => {
          let currentScroll = window.scrollY
          let maxScroll = document.body.scrollHeight - window.innerHeight

          if (currentScroll < maxScroll) {
            window.scrollTo(0, currentScroll + (maxScroll - currentScroll) / 8) // Adjust easing factor if needed
            requestAnimationFrame(smoothScrollToBottom)
          }
        }
        requestAnimationFrame(smoothScrollToBottom)
      } else {
        // Native smooth scroll for Chrome, Safari, and others
        window.scrollTo({
          top: document.body.scrollHeight,
          left: 0,
          behavior: "smooth",
        })
      }

      return
    }

    setIsCheckoutLoading(true)

    buttonClickAudio.play()

    window.onbeforeunload = null

    let eventID = uuidv4()
    console.log(eventID)
    if (isBrowser && window.fbq)
      window.fbq("track", "InitiateCheckout", {}, { eventID: eventID })

    const capi = await conversionsAPI(eventID, "InitiateCheckout")

    window.location = url.toString()
  }

  useEffect(() => {
    // console.log("Current audio time: ", currentAudioTime)
    if (stage === 1) {
      if (currentAudioTime > 25 && currentAudioStage === `more-to-your-story`) {
        setDisappearing(true)
        setTimeout(() => {
          // document.body.style.overflow = "auto"
          setStage(2)
          setDisappearing(false)
          setTimeout(() => setIsBorderAnimating(true), 3000)
        }, 700)
      }
    }
    if (stage === 2) {
      if (
        currentAudioTime > 44 &&
        (currentAudioStage === "guiding-star" ||
          currentAudioStage === "guiding-star-breakfast")
      ) {
        setDisappearing(true)
        setTimeout(() => {
          // document.body.style.overflow = "auto"
          setStage(3)
          setDisappearing(false)
        }, 700)
      }
    }
  }, [currentAudioTime])

  useEffect(() => {
    if (audioEnded) {
      // Go to next clip
      const filename = mainAudio.src.split("/").pop()
      mainAudio.pause()

      if (currentAudioStage === `phew-${selectedSign.toLowerCase()}`) {
        setCurrentAudioStage(`more-to-your-story`)
        mainAudio.src = `/audio/more-to-your-story.mp3`
        mainAudio.play()
        setAudioEnded(false)
      }

      if (currentAudioStage === "more-to-your-story") {
        if (
          window.location.search.includes("test=14") ||
          !window.location.search.includes("hop=astrozens")
        ) {
          setCurrentAudioStage(`guiding-star-breakfast`)
          mainAudio.src = `/audio/guiding-star-breakfast.mp3`
        } else {
          setCurrentAudioStage(`guiding-star`)
          mainAudio.src = `/audio/guiding-star-movie-ticket.mp3`
        }
        mainAudio.play()
        setAudioEnded(false)
      }
      if (
        currentAudioStage === "guiding-star" ||
        currentAudioStage === "guiding-star-breakfast"
      ) {
        setCurrentAudioStage(`crossroads`)
        mainAudio.src = `/audio/crossroads.mp3`
        mainAudio.play()
        setAudioEnded(false)
      }
      if (currentAudioStage === "crossroads") {
        setCurrentAudioStage(`final-push`)
        mainAudio.src = `/audio/final-push.mp3`
        mainAudio.play()
        setAudioEnded(false)
      }
    }
  }, [audioEnded])

  // Dynamically load handwriting font
  useEffect(() => {
    const link = document.createElement("link")
    link.href =
      "https://fonts.googleapis.com/css2?family=Playwrite+AU+QLD:wght@100..400&display=swap"
    link.rel = "stylesheet"
    document.head.appendChild(link)

    if (isBrowser) window.finishHop()
  }, [])

  return (
    <>
      <a
        id="affiliatelink"
        className="hidden"
        href="https://truthstars.pay.clickbank.net/"
      />
      {/* Preload images */}
      {/* <div className="hidden">
        <StaticImage
          quality={95}
          src="../images/cover-min.png"
          placeholder="blurred"
          alt={"Meditation"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          src="../images/paypal.png"
          placeholder="blurred"
          alt={"Intelligence"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          src="../images/visa.png"
          placeholder="blurred"
          alt={"loving hand"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          src="../images/mastercard.png"
          placeholder="blurred"
          alt={"loving hand"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          src="../images/american-express.png"
          placeholder="blurred"
          alt={"loving hand"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          src="../images/sarah.jpg"
          placeholder="blurred"
          alt={"loving hand"}
          className="hidden"
        />
        <StaticImage
          quality={95}
          src="../images/guarantee-min.png"
          placeholder="blurred"
          alt={"loving hand"}
          className="hidden"
        />
      </div> */}
      {stage === 1 && (
        <div
          className={`text-center fade-in ${
            disappearing ? "disappear transition duration-1000" : ""
          }`}
        >
          <h1 className="text-2xl font-bold text-white md:text-4xl">
            You're Almost There, {firstName}!{" "}
            <FaHeart className="inline-block -translate-y-0.5 text-brand-pink" />
          </h1>

          {/* Preload handwriting font */}
          <div className="invisible font-handwriting">Preloading font</div>
          {/* ************************** */}

          <div className="relative flex items-center justify-center">
            {/* Container for images */}
            <div className="relative">
              {/* Zodiac Glow Image (background) */}
              <StaticImage
                quality={95}
                src="../images/loving-hand.png"
                loading={"eager"}
                placeholder="blurred"
                alt="Loving hand"
                className="w-64 h-64 rounded-full zodiac-glow md:w-96 md:h-96"
                style={{
                  position: "absolute",
                  zIndex: 1,
                }}
              />

              {/* Slow Pulse Image (foreground) */}
              <StaticImage
                quality={95}
                src="../images/loving-hand.png"
                loading={"eager"}
                placeholder="blurred"
                alt="Loving hand"
                className="w-64 h-64 rounded-full slow-pulse md:w-96 md:h-96"
                style={{
                  position: "relative",
                  zIndex: 2,
                }}
              />
            </div>
          </div>
        </div>
      )}

      {stage === 2 && (
        <div
          className={`fade-in ${
            disappearing ? "disappear transition duration-1000" : ""
          }`}
        >
          <div className="flex justify-center">
            <div className="relative">
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/cover-min.png"
                placeholder="blurred"
                alt={"Report cover"}
                className={`w-64 md:w-96 cover-glow`}
              />
              {isBorderAnimating && (
                <>
                  <div className="top-edge" />
                  <div className="right-edge" />
                  <div className="bottom-edge" />
                  <div className="left-edge" />
                </>
              )}
              <div className="absolute w-full px-3 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
                <div className="p-4 text-xl text-center text-white font-handwriting md:text-3xl overflow-clip bg-black/50">
                  For {firstName} {lastName}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {stage === 3 && (
        <div
          className={`w-full bg-brand-dark cover-glow rounded-lg px-4 pt-4 pb-1 fade-in ${
            disappearing ? "disappear transition duration-1000" : ""
          }`}
        >
          <div className="mb-4 text-sm font-bold text-center text-white md:mb-8 md:text-xl">
            <span className="text-brand-gold">Don't Miss Out,</span> {firstName}
            .
            <br />
            There's So Much{" "}
            <span className="text-brand-gold">More To Be Revealed...</span>
          </div>
          {/* Mobile */}
          <div className="flex flex-wrap sm:hidden">
            <div className="flex w-full md:w-1/2">
              <div className="flex flex-wrap">
                <div className="flex justify-center w-1/2">
                  <div className="relative">
                    <StaticImage
                      quality={95}
                      loading={"eager"}
                      src="../images/cover-min.png"
                      placeholder="blurred"
                      alt={"Report cover"}
                      className={`w-32`}
                    />
                    <div className="absolute w-full px-1 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
                      <div className="p-2 text-xs text-center text-white font-handwriting md:text-3xl overflow-clip bg-black/50">
                        For {firstName} {lastName}
                      </div>
                    </div>
                    <div className="absolute bottom-0.5 left-0.5">
                      <img
                        src={pdfDownload}
                        className="w-6 opacity-80"
                        alt="pdf download"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-center w-1/2 pl-1">
                  <p className="text-xs text-white">
                    Click the button below, and I'll start writing your
                    personal, 50+ page report right now. Joy, love, abundance...
                    your new life is just a click away!
                  </p>
                  <br />
                  <p className="text-xs italic text-white">
                    Your friend and guide,
                    <br />
                    James Seabrook
                  </p>
                </div>
                <div className="w-full px-4 mx-auto text-center">
                  <p className="mt-4 text-sm font-bold text-center text-white">
                    James Seabrook is available.
                    <br />
                    But hurry...{" "}
                    <span className="text-brand-gold">only 1 slot left!</span>
                  </p>
                  <button
                    className={`${
                      isCheckoutLoading && "button-loading"
                    } px-0 mt-2 py-3 w-full text-sm font-bold text-white rounded-lg continue-pulse button-glow bg-brand-darkPink`}
                    type="button"
                    disabled={isCheckoutLoading}
                    onClick={() => handleOrder()}
                  >
                    <div className="flex items-center justify-around">
                      <FaArrowRight />
                      <div>START MY NEW LIFE NOW</div>
                      {/* <div className="flex space-x-1">
                        <HiOutlineShoppingCart className="w-5 h-5 " />
                      </div> */}
                      <FaArrowLeft />
                    </div>
                  </button>
                  <label className="flex items-center mt-3 space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      className="w-5 h-5 accent-blue-500"
                      checked={agreed}
                      onChange={e => {
                        setAgreed(e.target.checked)
                        if (e.target.checked) setIsAgreementError(false)
                      }}
                    />
                    <span className="text-xs text-justify text-gray-200">
                      I acknowledge and agree
                      <br />
                      to be bound by the{" "}
                      <a
                        target="_blank"
                        href="https://www.thetruthinyourstars.com/terms-and-conditions"
                        className="text-gray-400"
                      >
                        Terms & Conditions.
                      </a>
                    </span>
                  </label>
                  {isAgreementError && (
                    <p
                      onClick={e => {
                        setAgreed(true)
                        setIsAgreementError(false)
                      }}
                      className="px-1 mt-1 text-sm text-left text-white bg-red-700 cursor-pointer fade-in bg-opacity-60"
                    >
                      ☝{" "}
                      <span className="font-bold">Your new life awaits,</span>{" "}
                      but you'll need to check this box first!
                    </p>
                  )}
                </div>
                {/* <div className="w-full mt-2 text-xs text-center text-gray-300">
                  All orders are processed on a secure server.
                </div>
                <div className="flex justify-center w-full mt-2 space-x-2">
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/paypal.png"
                    placeholder="blurred"
                    alt={"Paypal"}
                    className={`w-8`}
                  />
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/visa.png"
                    placeholder="blurred"
                    alt={"visa"}
                    className={`w-8`}
                  />
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/mastercard.png"
                    placeholder="blurred"
                    alt={"mastercard"}
                    className={`w-8`}
                  />
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/american-express.png"
                    placeholder="blurred"
                    alt={"american-express"}
                    className={`w-8`}
                  />
                </div> */}
              </div>
            </div>
            <div className="flex items-center w-full py-6 md:w-1/2">
              <div className="flex">
                <div className="flex justify-center w-1/3">
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/sarah.jpg"
                    placeholder="blurred"
                    alt={"Sarah"}
                    className={`w-20`}
                  />
                </div>
                <div className="w-2/3 pl-1">
                  <p className="text-xs italic text-gray-100">
                    I've never considered myself a lucky person, but after
                    reading James' truth report, everything changed. Within
                    days, unexpected opportunities started coming my way. Best
                    decision I've ever made!
                    <br />- Sarah H. (Tucson, AZ)
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="flex flex-col items-center w-full text-xs text-gray-300">
             <div className="">
               <StaticImage
                 quality={95}
                 loading={"eager"}
                 src="../images/guarantee-min.png"
                 placeholder="blurred"
                 alt={"guarantee-min"}
                 className={`w-24`}
               />
             </div>
             <div className="px-4">
               <p>
                 Order now and you'll have your personal Truth Report sent to
                 you as soon as I've finished writing it (within 24 hours). In
                 the unlikely event that you aren't astonished by the
                 life-altering readings in your report, just shoot a quick
                 email to james@thetruthinyourstars.com within 60 days of
                 purchase, and I'll send you a full refund. You have nothing to
                 lose, and everything to gain!
               </p>
             </div>
           </div> */}
          </div>
          {/* Desktop */}
          <div className="flex-wrap hidden sm:flex">
            <div className="flex justify-center w-1/2">
              <div className="flex flex-wrap">
                <div className="relative flex justify-center w-full">
                  <StaticImage
                    quality={95}
                    loading={"eager"}
                    src="../images/cover-min.png"
                    placeholder="blurred"
                    alt={"Report cover"}
                    imgStyle={{ objectFit: "fill" }}
                    className={`w-64`}
                  />
                  <div className="absolute w-full px-1 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
                    <div className="p-2 text-xs text-center text-white font-handwriting md:text-xl overflow-clip bg-black/50">
                      For {firstName} {lastName}
                    </div>
                  </div>
                  <div className="absolute bottom-0.5 left-0.5">
                    <img
                      src={pdfDownload}
                      className="w-12 opacity-80"
                      alt="pdf download"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col w-1/2">
              <p className="text-sm text-white">
                Click the button below, and I'll start writing your personal,
                50+ page report right now. Joy, love, abundance... your new life
                is just a click away!
              </p>
              <p className="mt-4 text-sm italic text-white">
                Your friend and guide,
                <br />
                James Seabrook
              </p>
              <p className="mt-4 font-bold text-center text-white">
                James Seabrook is available.
                <br />
                But hurry...{" "}
                <span className="text-brand-gold">only 1 slot left!</span>
              </p>
              <button
                className={`${
                  isCheckoutLoading && "button-loading"
                } px-4 py-3 mt-2 font-bold text-white rounded-lg continue-pulse button-glow bg-brand-darkPink`}
                type="button"
                disabled={isCheckoutLoading}
                onClick={() => handleOrder()}
              >
                <div className="flex items-center justify-around">
                  <FaArrowRight />
                  <div>START MY NEW LIFE NOW</div>
                  {/* <div className="flex space-x-1">
                    <HiOutlineShoppingCart className="w-6 h-6 " />
                  </div> */}
                  <FaArrowLeft />
                </div>
              </button>
              <label className="flex items-center mt-3 space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  className="w-5 h-5 accent-blue-500"
                  checked={agreed}
                  onChange={e => {
                    setAgreed(e.target.checked)
                    if (e.target.checked) setIsAgreementError(false)
                  }}
                />
                <span className="text-sm text-gray-200">
                  I acknowledge and agree <br />
                  to be bound by the{" "}
                  <a
                    target="_blank"
                    href="https://www.thetruthinyourstars.com/terms-and-conditions"
                    className="text-gray-400"
                  >
                    Terms & Conditions.
                  </a>
                </span>
              </label>
              {isAgreementError && (
                <p
                  onClick={e => {
                    setAgreed(true)
                    setIsAgreementError(false)
                  }}
                  className="px-1 mt-1 text-white bg-red-700 cursor-pointer bg-opacity-60 fade-in"
                >
                  ☝ <span className="font-bold">Your new life awaits,</span>{" "}
                  but you'll need to check this box first!
                </p>
              )}
              {/* <div className="w-full mt-4 text-sm text-center text-gray-300">
                All orders are processed on a secure server.
              </div>
              <div className="flex justify-center w-full mt-2 space-x-2">
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/paypal.png"
                  placeholder="blurred"
                  alt={"Paypal"}
                  className={`w-12`}
                />
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/visa.png"
                  placeholder="blurred"
                  alt={"visa"}
                  className={`w-12`}
                />
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/mastercard.png"
                  placeholder="blurred"
                  alt={"mastercard"}
                  className={`w-12`}
                />
                <StaticImage
                  quality={95}
                  loading={"eager"}
                  src="../images/american-express.png"
                  placeholder="blurred"
                  alt={"american-express"}
                  className={`w-12`}
                />
              </div> */}
              <div className="flex items-center w-full mt-6">
                <div className="flex">
                  <div className="flex justify-center w-1/3">
                    <StaticImage
                      quality={95}
                      loading={"eager"}
                      src="../images/sarah.jpg"
                      placeholder="blurred"
                      alt={"Sarah"}
                      className={`w-24`}
                    />
                  </div>
                  <div className="w-2/3 pl-1">
                    <p className="text-sm italic text-gray-100">
                      I've never considered myself a lucky person, but after
                      reading James' truth report, everything changed. Within
                      days, unexpected opportunities started coming my way. Best
                      decision I've ever made!
                      <br />- Sarah H. (Tucson, AZ)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="flex items-center w-full mt-12 text-xs text-gray-300">
             <div className="">
               <StaticImage
                 quality={95}
                 loading={"eager"}
                 src="../images/guarantee-min.png"
                 placeholder="blurred"
                 alt={"guarantee-min"}
                 className={`w-28`}
               />
             </div>
             <div className="">
               <p>
                 Order now and you'll have your personal Truth Report sent to
                 you as soon as I've finished writing it (within 24 hours). In
                 the unlikely event that you aren't astonished by the
                 life-altering readings in your report, just shoot a quick
                 email to james@thetruthinyourstars.com within 60 days of
                 purchase, and I'll send you a full refund. You have nothing to
                 lose, and everything to gain!
               </p>
             </div>
           </div> */}
          </div>
          <div className="mt-6" />
          {/* <p className="mt-6 text-xs text-center text-gray-400 md:text-sm">
            Includes weekly updates for 29 usd per month,{" "}
            <br className="block sm:hidden" />
            which you may cancel at any time
          </p> */}
        </div>
      )}
    </>
  )
}

export default CloseTheSale
